(() => {
  if (window.hrcCardWhatsAppTrackingReady) return;
  window.hrcCardWhatsAppTrackingReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hrc-card-whatsapp]');
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'whatsapp_click',
      product_id: String(link.dataset.productId || ''),
      product_name: link.dataset.productName || '',
      variant_id: String(link.dataset.variantId || ''),
      variant_name: link.dataset.variantName || '',
      stock_status: 'sold_out',
      placement: 'product_card',
      trigger: 'sold_out_restock',
      measurement_source: 'hrc_theme_whatsapp_experiment',
    });
  });
})();
